import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, EDIT, YES, ACTIVE } from "const"
import {
    StoreType,
    moduleIds,
    setSilAssumptionBaseRoute,
} from "client/store"
import {
    projectsRoute,
    projectBaseRoute,
    silCalculationAssumptionsRoute,
} from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"

import AssumptionView from "./view"
import AssumptionEdit from "./edit"

const SilCalculationAssumptions = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const dispatch = useDispatch()

    const { silModuleAccess } = packageSettings
    const moduleAccess = silModuleAccess === YES && moduleList[moduleIds.sil].status === ACTIVE

    const baseRouteMask = `${projectBaseRoute}${silCalculationAssumptionsRoute}`
    const baseRoute = `${projectsRoute}/${VIEW}/${project.id}${silCalculationAssumptionsRoute}`

    useEffect(() => {
        dispatch(setSilAssumptionBaseRoute(baseRoute))
    }, [])

    if (!moduleAccess) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${baseRouteMask}/${EDIT}`}
                component={AssumptionEdit}
            />
            <Route
                path={baseRouteMask}
                component={AssumptionView}
            />
        </Switch>
    )
}
export default SilCalculationAssumptions
